import styled from "@emotion/styled";
import { css } from "@emotion/core";
import { NectarTheme } from "@nectarTypes";
import { Link } from "react-router-dom";
import { ToggleTip } from "nectar-ui";

export const HeadingInfoContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    display: flex;
    flex-direction: row;
    column-gap: ${theme.spacings.xxs};
    margin-bottom: ${theme.spacings.xs};
  `}
`;

export const InfoContainer = styled.div<NectarTheme>`
  ${({ _theme }) => css`
    span:only-child {
      display: none;
    }
  `}
`;

export const CustomLink = styled(Link)<NectarTheme>`
  ${({ theme }) => css`
    font-size: 16px;
    font-style: normal;
    font-weight: 300;
    line-height: 140%;
    color: ${theme.colors.primary500};
  `}
`;

export const CustomToggletip = styled(ToggleTip)<NectarTheme>`
  ${({ _theme }) => css`

      & div {
        background-color: blueviolet;
      }

      & > div[aria-label="Caixa texto explicativo"] {
        left: 24px;
        top -1px;
        background-color: red;
      }
    
  `}
`;

export const appealIncidentTree = css``;

export const MovementTabContainer = styled.div<NectarTheme>`
  ${({ theme }) => css`
    .rst__lineBlock,
    .rst__lineBlock20px {
      width: 25px;
      min-width: 25px;
      position: relative;
      display: inline-block;
    }

    .rst__lineBlock20px {
      width: 20px;
      min-width: 20px;
    }

    .rst__lineHalfHorizontalRight::before,
    .rst__lineSixtyHorizontalRight::before,
    .rst__lineFullVerticalHalf::after,
    .rst__lineFullVerticalSixty::after,
    .rst__lineHalfVerticalTop::after,
    .rst__lineSixtyVerticalTop::after {
      position: absolute;
      content: "";
      background-color: ${theme.colors.gray300};
      @media print {
        background-color: unset;
        box-shadow: inset 0 0 0 1000px ${theme.colors.gray300};
      }
    }

    .rst__lineHalfHorizontalRight::before,
    .rst__lineSixtyHorizontalRight::before {
      height: 1px;
      top: 50%;
      right: 0;
      width: 50%;
    }

    .rst__lineSixtyHorizontalRight::before {
      width: 60%;
    }

    .rst__lineFullVerticalHalf::after,
    .rst__lineHalfVerticalTop::after,
    .rst__lineFullVerticalSixty::after,
    .rst__lineSixtyVerticalTop::after {
      height: 100%;
      width: 1px;
      top: 0;
      left: 50%;
    }

    .rst__lineFullVerticalSixty::after,
    .rst__lineSixtyVerticalTop::after {
      left: 40%;
    }

    .rst__lineHalfVerticalTop::after,
    .rst__lineSixtyVerticalTop::after {
      height: 50%;
    }
  `}
`;
